var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.getFlag,"max-width":_vm.size,"max-height":_vm.size,"aspect-ratio":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }